import React from 'react';
import { twMerge } from 'tailwind-merge';

type SimilarStockItemButtonProps = {
  text: string;
};

const SimilarStockItemButton = ({ text }: SimilarStockItemButtonProps) => {
  return (
    <button
      className={twMerge(
        'text-white absolute right-2 mt-4 mr-2 px-4 py-2 font-semibold text-sm border-0 cursor-pointer z-10 transition-all bg-gray-500 hover:bg-gray-600 bg-opacity-75 hover:bg-opacity-50 rounded-lg'
      )}
      onClick={() => {
        const element = document.getElementById('stock-item-info');
        element?.scrollIntoView({ behavior: 'smooth' });
      }}
    >
      {text}
    </button>
  );
};

export default SimilarStockItemButton;
